import { supabaseClient } from '../../config/supabase';
import VerificationCodeForm from './VerificationCodeForm';
export { AUTH_SUCCESS_PAUSE_MS, SIGN_IN_AFTER_SAVE_ERROR } from './VerificationCodeForm';

export default function VerificationCodeCard(props) {
    return <VerificationCodeForm {...props} client={supabaseClient} />;
}
